export default __webpack_public_path__ + "static/media/avaya-onecloud-top-logo.80fb65ba.svg";